import React, { useState } from "react";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

const CustomInput = (props) => {
  const {
    label,
    type,
    inputType,
    placeholder,
    value,
    onChange,
    name,
    error,
    className,
    inputStyle,
    maxLength,
    labelStyle,
    disabled,
    onlyNumbers = false,
    required = false,
    labelGap,
    unit,
    allowDecimalFormat = false,
    decimalMaxDigits = 4,
    disableAutocomplete = true,
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const actualType = type || inputType || "text";
  const isPassword = actualType === "password";
  const isNumber = actualType === "number" || onlyNumbers;

  const handleChange = (e) => {
    const val = e.target.value;

    if (allowDecimalFormat) {
      const [intPart = "", decimalPart = ""] = val.split(".");

      // Allow only digits and a single optional dot
      if (!/^\d*\.?\d*$/.test(val)) return;

      // Validate based on digits before and after decimal
      if (intPart.length > decimalMaxDigits || decimalPart.length > 2) return;

      onChange?.(e);
    } else if (isNumber) {
      if (val && !/^\d*$/.test(val)) return;
      onChange?.(e);
    } else {
      onChange?.(e);
    }
  };



  return (
    <div className={`relative ${className}`}>
      <div className={`relative flex flex-col gap-0.5 ${labelGap}`}>
        {label && (
          <label htmlFor={name} className={`block text-sm ${labelStyle}`}>
            {label}
            {
              unit && (
                <span className="text-gray-500 text-xs" >({unit})</span>
              )
            }
          </label>
        )}

        <input
          type={
            isPassword
              ? showPassword
                ? "text"
                : "password"
              : type
          }

          step={isNumber ? (allowDecimalFormat ? "0.01" : "1") : undefined}
          inputMode={allowDecimalFormat ? "decimal" : isNumber ? "numeric" : undefined}
          pattern={allowDecimalFormat || isNumber ? "[0-9]*" : undefined}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          disabled={disabled}
          required={required}
          autoComplete={"off"}
          onKeyDown={(e) => {
            if (isNumber && ["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          className={`
            w-full px-3 !py-[3px] sm:text-base text-sm border-2 border-gray-200 rounded-xl
            focus:outline-none
            ${error ? "border-red-500" : ""}
            ${disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : "bg-input-bg"}
            peer
            ${inputStyle}
          `}
        />

        {isPassword && (
          <button
            type="button"
            className="absolute right-3 top-[58%]"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <IoIosEyeOff className="text-gray-500" size={20} />
            ) : (
              <IoIosEye className="text-gray-500" size={20} />
            )}
          </button>
        )}
      </div>

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default CustomInput;
